<template>
  <div></div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "PageAllow",

  props: {
    controller: String,
    action: String,
    prohibit: Boolean,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["allow"]),
  },

  mounted() {
    this.check();
  },

  watch: {
    controller: {
      handler() {
        this.check();
      },
    },
    action: {
      handler() {
        this.check();
      },
    },
    allow: {
      handler() {
        this.check();
      },
    },
  },

  methods: {
    check() {
      if (this.allow) {
        let controller = this.allow[this.controller];
        if (controller) {
          if (!controller.find((action) => this.action == action))
            this.$router.push("/page403");
          //找到了controller找不到action
          else if (this.prohibit) this.$router.push("/page403"); //有额外判断条件且额外条件判断失败
        } else this.$router.push("/page403"); //找不到controller
      }
    },
  },
};
</script>
